import Top from 'employeeFiles/Top'

export default {Top}
